import React from 'react';
import cx from 'classnames';
import styles from './page.module.css';

interface PageProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: React.ReactNode;
  variant?: 'show-overflow';
}

export const Page: React.FC<PageProps> = ({ children, className, title, subtitle, variant }) => {
  return (
    <div className={cx(styles.container, variant === 'show-overflow' && styles.visibleOverflow, className)}>
      {(title !== undefined || subtitle !== undefined) && (
        <div className={styles.headerContainer}>
          {title && <h1 className={styles.title}>{title}</h1>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Page;
